import Highcharts from 'highcharts';
import {numberRange} from './utilities';

export const figure22 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    exporting: {
        enabled: false
    },

    xAxis: [{
        categories: numberRange(2001, 2019),
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#4472c4'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: .6,
        min: 0,
        tickInterval: .1,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                //enabled: false,
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ {
        name: 'Índice de orientación agrícola',
        id: "prev",
        type: 'line',
        color: '#5b9bd5',

        zoneAxis: 'x',
        // zones: [{
        //     value: 13
        // }, {
        //     dashStyle: 'dot'
        // }],

        dataLabels: {
            enabled: false,
            // formatter: function () {
            //     return this.y.toFixed(1)+"%";
            // },
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }

        },

        data: [0.52, 0.4657, 0.4566, 0.4401, 0.49, 0.4899, 0.4372, 0.4506, 0.4466, 0.45, 0.4413, 0.4564, 0.4541, 0.4584, 0.50, 0.4977, 0.4969, 0.54, 0.53],
        // tooltip: {
        //     valueSuffix: '%'
        // }
    }],


};
